function initTabElements() {
    $(".frame-type-mask_ce_tab_element .nav-link").click(function() {
        $(this).closest(".frame-type-mask_ce_tab_element").addClass("tab-show-mobile");
    });
}
